<template>
    <div class="loading-component" ref="loadingContainer">
        <h2 v-if="showMessage" class="text-center">{{message}}</h2>
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"
                 :color="color"
                 :loader="type"
                 :width="width"
                 :height="height"
                 :class="noBg ? 'no-bg' : ''"
        ></loading>
    </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    name: 'LoadingAnimation',

    props: {
      showMessage: {
          type: Boolean,
          default: false,
      },

      message: {
          type: String,
          default: 'Loading...',
      },

      width: {
        type: Number,
        default: 80
      },

      height: {
        type: Number,
        default: 80
      },

      type: {
        type: String,
        default: 'bars',
      },

      noBg: {
        type: Boolean,
        default: false
      },
    },

    data() {
      return {
        isLoading: true,
        fullPage: false,
        color: '#1DC071'
      }
    },

    mounted () {
      window.scrollTo(0,0)
    },
    components: {
      Loading
    },
    methods: {

    }

  }
</script>

<style lang="scss" scoped>
.vld-overlay {
    position: relative;
}

h2 {
  font-family: Circular Std;
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  line-height: 33px;
  color: #000000;
}

.loading-component::v-deep {
  .no-bg {
    .vld-background {
      background: none!important;
    }
  }
}

</style>